import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../lifechronicles/LifeChroniclesHome.css';

import {
  faPiggyBank,
  faUserCheck,
  faCalendarDays,
  faCheckCircle,
  faUtensils,
  faCarrot,
  faMobileScreen,
  faCloudMoon,
  faHandHoldingHeart,
  faTree,
  faStar,
  faSeedling,
  faDumbbell,
  faGift,
  faFaceSmile,
  faBreadSlice,
  faBullseye,
  faHandsPraying,
  faHospitalUser,
  faMoneyBillWave,
  faEnvelopeOpenText,
  faExclamationTriangle,
  faPrescriptionBottleMedical,
  faCameraRetro,
  faHourglassEnd,
  faShoppingBasket,
  faFaceGrinHearts,
  faCalendarPlus,
  faDog,
  faCashRegister,
  faRulerCombined,
  faClipboardList,
  faGamepad,
  faTrash,
  faUsers,
  faBookOpen,
  faReceipt,
  faHeartCircleCheck,
  faHeartPulse,
  faTasks,
  faBrain,
  faSuitcase,
  faFolderOpen,
  faSyringe,
  faCar,
  faLeaf,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";

export const categories = [
    { to: "/calendar-list", icon: faCalendarDays, label: "Calendar", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/checklist-list", icon: faCheckCircle, label: "Checklist", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/experience-list", icon: faSeedling, label: "Experience", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/goals-list", icon: faBullseye, label: "Goals", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/planner-list", icon: faClipboardList, label: "Planner", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/tasks-list", icon: faTasks, label: "Task", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/todo-list", icon: faListCheck, label: "ToDo", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/travels-list", icon: faSuitcase, label: "Travels", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/visits-list", icon: faCar, label: "Visit", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/gift-list", icon: faGift, label: "Gifts", bgColor: "bg-red-500", textColor: "text-white" },
    { to: "/dreams-list", icon: faCloudMoon, label: "Dreams", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/empathy-list", icon: faHandHoldingHeart, label: "Empathy", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/feelings-list", icon: faFaceSmile, label: "Feelings", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/gratitude-list", icon: faHandsPraying, label: "Gratitude", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/issues-list", icon: faExclamationTriangle, label: "Issues", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/mood-list", icon: faFaceGrinHearts, label: "Mood", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/regrets-list", icon: faTrash, label: "Regret", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/socialactivity-list", icon: faUsers, label: "Social-Activity", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/sympathy-list", icon: faHeartCircleCheck, label: "Sympathy", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/thoughts-list", icon: faBrain, label: "Thoughts", bgColor: "bg-gray-600", textColor: "text-white" },  
    { to: "/environment-list", icon: faTree, label: "Environment", bgColor: "bg-green-600", textColor: "text-white" },
    { to: "/expense-list", icon: faStar, label: "Expense", bgColor: "bg-cyan-600", textColor: "text-white" },
    { to: "/events-list", icon: faStar, label: "Events", bgColor: "bg-cyan-600", textColor: "text-white" },
    { to: "/food-list", icon: faBreadSlice, label: "Food", bgColor: "bg-cyan-600", textColor: "text-white" },  
    { to: "/unspecified-list", icon: faFolderOpen, label: "Unspecified", bgColor: "bg-red-800", textColor: "text-white" },
];

const BhaktiChroniclesHome = () => {
    const navigate = useNavigate();

    return (
        <div>
            <div className="flex flex-col mt-1 items-center py-2 px-4 bg-black border border-pink-400 h-auto rounded-lg">
                <p className="text-lg lg:text-xl mb-1 text-yellow-200">Bhakt Daily Life: Actions & Reflections</p>
                <div className='flex flex-col flex-wrap justify-center gap-4 mt-2 text-sm'>
                    <div className="grid grid-cols-3 lg:grid-cols-7 gap-2">
                        {categories.map((category, index) => (
                            <Link 
                                key={index} 
                                to={category.to} 
                                className={`flex flex-col items-center p-2 lg:p-4 rounded-lg ${category.bgColor} ${category.textColor} shadow-lg hover:shadow-2xl transition-shadow duration-300`}
                            >
                                <FontAwesomeIcon icon={category.icon} size="x" className="mb-2" />
                                <span className="text-m flex items-center justify-center text-center">{category.label}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
            <footer className="bg-[#2a0f2f] border-t border-pink-800 text-pink-300 py-4">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-xs lg:text-sm">
                    © 2025 Think5Whys Global DeepTech Solutions.
                    </div>
                    <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                        <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
                        <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
                        <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
                        <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
                    </div>
                </div>
            </footer>            
        </div>
    );
};

export default BhaktiChroniclesHome;
